import { IconInfoCircle } from "@tabler/icons-react";
import { Interweave } from "interweave";
import { Fragment, forwardRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Checkbox } from "src/components/UI/Checkbox/Checkbox";
import { MODAL_TYPE } from "src/constants/modal-definitions";
import { STATIC_ELEMENT } from "src/constants/static";
import { useLocaleContext } from "src/context/locale-context";
import { useModalContext } from "src/context/modal-stack-context";
import useStaticContent from "src/hooks/useStaticContent";
import { bookingActions } from "src/store/booking";
import classes from "../PaymentOptions.module.css";

function transformTextToButtons(inputString, buttonsList) {
  let transformedString = inputString;
  buttonsList.forEach(
    (btn, index) =>
      (transformedString = transformedString.replace(
        btn.strVar,
        `<button value="${index}"><b>${btn.name}</b></button>`
      ))
  );
  return transformedString;
}

export const PaymentTermsComponent = forwardRef(function PaymentTermsComponent(props, ref) {
  const { getStringRes } = useLocaleContext();
  const dispatch = useDispatch();
  const { openModal } = useModalContext();

  const { html: tos } = useStaticContent(STATIC_ELEMENT.terms);
  const { html: guarantee } = useStaticContent(STATIC_ELEMENT.guarantee);
  const { html: refunds } = useStaticContent(STATIC_ELEMENT.refunds);
  const { html: privacy } = useStaticContent(STATIC_ELEMENT.privacy);
  const { html: deals_vouchers } = useStaticContent(STATIC_ELEMENT.deals_vouchers);

  const onShowFreeOffersDetails = (e) => {
    e.stopPropagation();
    openModal(MODAL_TYPE.serviceDetails, { template: deals_vouchers });
  };

  const isDealsOptedOut = useSelector((state) => state.booking.isOffersOptedOut);

  const buttonsList = [
    { name: "conditions", strVar: "##T_AND_C##", html: tos },
    { name: "guarantee", strVar: "##GUARANTEE_RULES##", html: guarantee },
    { name: "refunds", strVar: "##REFUND_RULES##", html: refunds },
    { name: "privacy", strVar: "##PRIVACY_POLICY##", html: privacy },
    {
      name: "Ryanair",
      strVar: "##RYANAIR_POLICY##",
      html: "",
      cb: () =>
        window.open(
          "https://www.ryanair.com/gb/en/useful-info/help-centre/terms-and-conditions",
          "_blank"
        ),
    },
  ].map(({ name, strVar, html, cb }) => ({
    name: name !== "Ryanair" ? getStringRes(`booking.checkout.payment.terms.${name}`) : name,
    strVar,
    cb:
      cb ||
      (() =>
        openModal(MODAL_TYPE.documentView, {
          title: getStringRes(`booking.checkout.payment.terms.${name}`),
          template: html,
        })),
  }));

  const termsAndConditions = transformTextToButtons(
    getStringRes("booking.checkout.payment.terms"),
    buttonsList
  );

  return (
    <Fragment>
      <div className={classes.terms}>
        <IconInfoCircle size={18} />
        <span className={classes.text}>
          <Interweave
            noWrap
            content={termsAndConditions}
            transform={(node, children) => {
              if (node.tagName === "BUTTON") {
                const idx = node.getAttribute("value");
                return (
                  <button onClick={buttonsList[idx].cb} className={classes.docbtn}>
                    {children}
                  </button>
                );
              }
            }}
          />
        </span>
      </div>
      <div className={classes.dealsOptOut}>
        <Checkbox
          id="deals-vouchers-opt-out-option"
          isChecked={isDealsOptedOut}
          onChange={() =>
            dispatch(bookingActions.updateSkipOffersEmailsStatus(!isDealsOptedOut))
          }
          name="deals-vouchers-opt-out"
          isSameAsMobile
          isClickTextEnabled={false}
          checkMarkColor="#fff"
          ariaLabel={
            getStringRes("booking.checkout.payment.deals.optout") +
            " " +
            getStringRes("booking.checkout.payment.deals.optout.info")
          }
          label={
            <span className={classes.text}>
              {getStringRes("booking.checkout.payment.deals.optout")}{" "}
              <button
                style={{
                  padding: "0",
                  background: "none",
                  border: "none",
                  textDecorationLine: "underline",
                }}
                onClick={onShowFreeOffersDetails}>
                <b>{getStringRes("booking.checkout.payment.deals.optout.info")}</b>
              </button>
            </span>
          }
        />
      </div>
    </Fragment>
  );
});
